export default __webpack_public_path__ + "static/media/ButtonHover.min.8ef7a573.png";